<div class="overlaySpinner">
    <div class="spinner-border querySpinner" role="status"></div>
</div>